import { Injectable, inject } from '@angular/core';
import { Query } from '@datorama/akita';

import { LoanApplicationNote } from '../../cmg-1003/models/notes.model';
import { ApplicationNotesDataStore } from './application-notes.store';
import { DirtyChecker2 } from '../../loan-state/core/dirty-checker-2';

@Injectable({ providedIn: 'root' })
export class ApplicationNotesQuery extends Query<LoanApplicationNote> {
  protected store: ApplicationNotesDataStore;

  dirtyChecker2: DirtyChecker2 = new DirtyChecker2(this.store, this);
  constructor() {
    const store = inject(ApplicationNotesDataStore);

    super(store);
    this.store = store;

    this.dirtyChecker2.dirtyChecker.setHead();
  }
}
